import React, { useEffect } from "react";
import "./Video.scss";
import VideoAlta from "../../../assets/images/bupin_video_2.mp4";

const Video = () => {
  useEffect(() => {
    //set video height
    const video = document.querySelector("video");
    const videoHeight = video.clientHeight;
    const viewVideo = document.querySelector(".view-video");
    viewVideo.style.height = `${videoHeight}px`;
  }, []);

  return (
    <>
      <div className="view-video">
        <video width="100%"  loop autoPlay muted>
          <source src={VideoAlta} type="video/mp4" />
        </video>
      </div>
    </>
  );
};

export default Video;
